import { useNavigate, Link } from "react-router-dom";
import { LogOut, LayoutDashboard, LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { NotificationsBell } from "@/components/NotificationsBell";
import { MessagesButton } from "@/components/MessagesButton";

export function DashboardShell({ children, testid }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B]" data-testid={testid}>
      <header className="sticky top-0 z-40 bg-black/85 backdrop-blur-xl border-b border-zinc-800/80">
        <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto h-16 flex items-center justify-between">
          <button onClick={() => navigate("/")} className="flex items-center">
            <Logo size="h-7" />
          </button>
          <div className="flex items-center gap-1 sm:gap-2">
            <Link to="/support" title="Contact / Support" className="grid place-items-center w-9 h-9 rounded-full text-zinc-400 hover:text-white hover:bg-zinc-900 transition-colors" data-testid="dashboard-support-link">
              <LifeBuoy className="w-5 h-5" />
            </Link>
            <MessagesButton />
            <NotificationsBell />
            <div className="hidden sm:flex items-center gap-2 text-sm text-zinc-400 ml-1">
              <LayoutDashboard className="w-4 h-4" /> {user?.name}
            </div>
            <Button onClick={handleLogout} variant="outline" size="sm" className="border-zinc-700 bg-transparent hover:bg-zinc-900 hover:text-white rounded-full" data-testid="dashboard-logout-button">
              <LogOut className="w-4 h-4 mr-2" /> Logout
            </Button>
          </div>
        </div>
      </header>
      <main className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-8 md:py-10">{children}</main>
    </div>
  );
}

export function StatCard({ label, value, hint }) {
  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900/60 p-5">
      <p className="text-xs font-bold uppercase tracking-widest text-zinc-500">{label}</p>
      <p className="mt-2 font-display text-3xl font-black text-white">{value}</p>
      {hint && <p className="mt-1 text-xs text-zinc-500">{hint}</p>}
    </div>
  );
}
